<script setup lang="ts">
import RetryIcon from '@/assets/icons/shared/retry.svg';
import UiButton from '@/modules/ui/components/ui/UiButton.vue';

function refresh() {
  window.location.reload();
}
</script>

<template>
  <UiButton
    size="l"
    @click="refresh"
  >
    <span>{{ $t('ui.common.button.refresh') }}</span>
    <RetryIcon v-postfix />
  </UiButton>
</template>
